<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">
		<div class="header-container">
			<div class="search-swiper-container">
				<Swiper :list="international_sliders"/>
			</div>
		</div>

		<div class="content">
			<div class="news-container">
				<section id="news-wrapper" class="news-wrapper">
					<div class="tale-caption">
						<div class="tale-span" style="margin-bottom:10px;">
							<span>图文</span>
						</div>
					</div>
					<div class="news-right">
						<Loading :is-loading="isPicLoading"></Loading>
						<div class="news-item" v-for="item in picList" :key="item.id" @click="toDetail(item.id)">
							<div class="news-item-outer">
								<div class="img-outer">
									<img :src="item.thumb" oncontextmenu="return false" :alt="item.title"/>
								</div>
								<div class="news-title">
									<span v-html="item.title"></span>
								</div>
							</div>
						</div>
					</div>
				</section>
				<div class="loadmore">
					<Loading :is-loading="isPicLoading"></Loading>
					<span class="more" @click="loadMore(pictype)" v-if="!picNomore">{{$t('loadmore')}}</span>
					<span class="end" v-if="picNomore">- {{$t('theEnd')}} -</span>
				</div>
			</div>

			<div class="news-container" id="international-video-section">
				<section id="news-wrapper-video" class="news-wrapper">
					<div class="tale-caption">
						<div class="tale-span" style="margin-bottom:10px;">
							<span>视频</span>
						</div>
					</div>
					<div class="enclosure">
						<Loading :is-loading="isVideoLoading"></Loading>
						<section class="section masonry">
							<div class="masonry-column" v-for="(column, colIndex) in videoColumns" :key="colIndex">
								<div class="_1Aw4E" v-for="item in column" :key="item.id">
									<div @click="toVideoDetail(item.id)" style="width:100%;">
										<video v-if="isMobile"
											:poster="item.thumb"
											preload="none"
											muted=""
											:alt="item.title"
											:style="getVideoAspectStyle(item)"
											controlslist="nodownload"
											oncontextmenu="return false">
											<track kind="captions" />
											<source :src="item.video" type="video/mp4">
										</video>
										<video v-if="!isMobile"
											controls
											:poster="item.thumb"
											preload="none"
											muted=""
											:alt="item.title"
											:style="getVideoAspectStyle(item)"
											controlslist="nodownload"
											oncontextmenu="return false"
											:src="item.video">
											<track kind="captions" />
										</video>
									</div>
									<div class="video_name">
										<span v-html="item.title"></span>
									</div>
								</div>
							</div>
						</section>
					</div>
				</section>
				<div class="loadmore">
					<Loading :is-loading="isVideoLoading"></Loading>
					<span class="more" @click="loadMore(videotype)" v-if="!videoNomore">{{$t('loadmore')}}</span>
					<span class="end" v-if="videoNomore">- {{$t('theEnd')}} -</span>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import international from './international_controller';
export default international;
</script>

<style src="@/assets/css/tale.css" scoped></style>
